export const UPDATE_ACTIVE_VOUCHER = 'activeVoucher/UPDATE'

export function updateActiveVoucher(voucher, name) {
  return {
    type: UPDATE_ACTIVE_VOUCHER,
    voucher,
    name,
  }
}
